// extracted by mini-css-extract-plugin
export var icon = "_qt-0";